import React from "react";
import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";
import { formatEDSDate } from "@coworker/app/src/components/Insights/helpers";
import { EdsData } from "@coworker/app/src/components/RoomSettings/types/article";
import { useCountryId } from "@coworker/app/src/core/auth/useLoggedInUser";
import styles from "./media-item-eds.module.css";

interface ItemEDSProps {
  edsData: EdsData;
}

export const MediaItemEds = ({ edsData }: ItemEDSProps) => {
  const countryId = useCountryId();
  return (
    <React.Fragment>
      {edsData && edsData.validToDateTime && (
        <FixaText
          className={styles["item-eds-text"] || ""}
          textStyle={"Body.S"}
        >
          {`${
            new Date(edsData.validToDateTime) > new Date() ? "EDS" : "PEDS"
          } ${formatEDSDate(edsData.validToDateTime, countryId)}`}
        </FixaText>
      )}
    </React.Fragment>
  );
};
